import { ArrowUpRight } from "lucide-react";

export const APP_STORE_URL = "https://apps.apple.com/ca/app/saferide-community-carpool/id6790160969";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.emergent.maplerides.jlvvut&pcampaignid=web_share";

// Device-aware store link: Android → Google Play, iPhone/iPad → App Store,
// anything else → null (caller scrolls to the download section instead).
export const getDeviceStoreUrl = () => {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/android/i.test(ua)) return PLAY_STORE_URL;
  if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return APP_STORE_URL;
  return null;
};

export const openSmartStore = () => {
  const url = getDeviceStoreUrl();
  if (url) {
    window.open(url, "_blank", "noopener,noreferrer");
  } else {
    document.getElementById("download")?.scrollIntoView({ behavior: "smooth" });
  }
};

export const PrimaryButton = ({ children, testId, className = "", onClick, ...props }) => (
  <button
    data-testid={testId}
    onClick={onClick || openSmartStore}
    className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full bg-[#2340b5] px-8 py-4 font-display text-sm font-bold tracking-wide text-white shadow-lg shadow-[#2340b5]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1b3390] hover:shadow-xl hover:shadow-[#2340b5]/30 ${className}`}
    {...props}
  >
    <span className="relative z-10 flex items-center gap-2">{children}</span>
  </button>
);

export const GhostButton = ({ children, testId, className = "", ...props }) => (
  <button
    data-testid={testId}
    className={`group inline-flex items-center justify-center gap-2 rounded-full border border-[#12142b]/15 bg-white px-8 py-4 font-display text-sm font-bold tracking-wide text-[#12142b] transition-all duration-300 hover:border-[#2340b5] hover:text-[#2340b5] ${className}`}
    {...props}
  >
    {children}
    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.75} />
  </button>
);

export const StoreBadge = ({ store, testId }) => {
  const isApple = store === "apple";
  return (
    <a
      href={isApple ? APP_STORE_URL : PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="group flex items-center gap-3 rounded-2xl bg-[#12142b] px-5 py-3 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1b1d3a]"
    >
      <span className="text-white transition-transform duration-300 group-hover:scale-110">
        {isApple ? (
          <svg viewBox="0 0 24 24" className="h-7 w-7 fill-current" aria-hidden>
            <path d="M17.05 12.53c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.71-3.19-1.73-1.36-.14-2.65.8-3.34.8-.69 0-1.75-.78-2.88-.76-1.48.02-2.85.86-3.61 2.18-1.54 2.67-.39 6.62 1.1 8.79.73 1.06 1.6 2.25 2.74 2.21 1.1-.04 1.51-.71 2.84-.71 1.32 0 1.7.71 2.86.69 1.18-.02 1.93-1.08 2.65-2.15.84-1.23 1.18-2.42 1.2-2.48-.03-.01-2.29-.88-2.31-3.49zM14.86 5.82c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.55 1.31-.56.64-1.05 1.68-.92 2.67.97.08 1.96-.49 2.57-1.22z" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" className="h-6 w-6 fill-current" aria-hidden>
            <path d="M3.6 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l.1.1L13 12.1v-.2L3.7 2.2l-.1.1zm12.8 13.1L14 13v-.2l2.4-2.4.1.1 2.9 1.6c.8.5.8 1.3 0 1.7l-3 1.6zm-1.3-1.2L5.6 21.9c.3.2.7.2 1.2-.1l7.9-4.5-1.5-1.1zm0-3.8L6.8 2.1c-.5-.3-.9-.3-1.2-.1l9.5 8.6 1.5-1z" />
          </svg>
        )}
      </span>
      <span className="text-left leading-tight">
        <span className="block text-[10px] uppercase tracking-[0.15em] text-white/60">
          {isApple ? "Download on the" : "Get it on"}
        </span>
        <span className="block font-display text-base font-bold text-white">
          {isApple ? "App Store" : "Google Play"}
        </span>
      </span>
    </a>
  );
};
